import api from "../../../api";

export function cancelSlotApi(payload) {
  return api.post('v3/slot-cancellation', payload);
}
